export const textIsLink = (text) => {
    return new RegExp(`^https?:`).test(text);
};
